import * as React from 'react';
import { FormGroup, HelpBlock } from 'react-bootstrap';
import FormValidationService from '../../shared/form/FormValidationService';

interface IValidatableFormGroupProps {
    validationKey: string;
    controlId?: string;
    required?: boolean;
    errors: any;
    children?: any;
}

const ValidatableFormGroup = (props: IValidatableFormGroupProps) => {
    let controlId = props.controlId ? props.controlId : props.validationKey;
    let className = props.required && props.required === true ? 'required' : null;
    let validationState = FormValidationService.getValidationState(
        props.errors[props.validationKey]
    );
    return (
        <FormGroup
            controlId={controlId}
            data-validation-key={props.validationKey}
            className={className}
            validationState={validationState}
        >
            {props.children}
            {props.errors && props.errors[props.validationKey] && (
                <HelpBlock>{props.errors[props.validationKey]}</HelpBlock>
            )}
        </FormGroup>
    );
};

export default ValidatableFormGroup;
